import { Paths } from '../../../lib/constants/path'
import { Route } from '../../../lib/types/routes'
import { ContractTemplateCreatePage } from './contract-template-create'
import { ContractTemplateListPage } from './contract-template-list'
import { ContractTemplateUpdatePage } from './contract-template-update'

const contractRoutes: Route[] = [
  {
    path: Paths.CONTRACT_TEMPLATE_LIST_PAGE,
    element: <ContractTemplateListPage />
  },
  {
    path: Paths.CONTRACT_TEMPLATE_CREATE_PAGE,
    element: <ContractTemplateCreatePage />
  },
  {
    path: Paths.CONTRACT_TEMPLATE_UPDATE_PAGE,
    element: <ContractTemplateUpdatePage />
  }
]

export default contractRoutes
